import { validateModel } from '@sky-it-livedata-libraries/livedata-commons';
import { ICompetitionBoard } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const CompetitionBoardWrapper = React.lazy(() => import('./competition-board'));

export interface IDynamicCompetitionBoard extends IComponentModel<ICompetitionBoard> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicCompetitionBoard = ({
  /* istanbul ignore next: default value */ model = {} as ICompetitionBoard,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicCompetitionBoard) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <CompetitionBoardWrapper
      live={live}
      initialModel={validateModel(model) as ICompetitionBoard}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicCompetitionBoard;
